<script setup lang="ts">
import { VueFinalModal } from 'vue-final-modal'

defineProps<{
  title?: string
  maxHeight?: string
  closable?: boolean
}>()

const emit = defineEmits<{
  (e: 'confirm'): void
  (e: 'close'): void
  (e: 'refresh'): void
}>()
</script>

<template>
  <VueFinalModal
    class="vfm-fullscreen"
    content-class="vfm-fullscreen-content"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
  >
    <slot />
  </VueFinalModal>
</template>

<style lang="scss">
.vfm-fullscreen {
  display: flex;
  justify-content: center;
  align-items: center;

  .ps {
    max-height: 520px !important;
    &.ps--active-y {
      padding-right: 15px;
      margin-right: -15px;
    }
  }

  .arrow {
    width: 16px;
    height: 14px;
    margin: 25px auto 5px;
    transform: rotate(90deg);
  }

  .indigo-ui-outer {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .item-label {
    display: block;
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .two-columns {
    display: flex;
    max-width: 100%;
    overflow: hidden;

    .indigo-ui-outer {
      margin-right: 20px;
      &:last-child {
        margin: 0;
      }
    }
  }
}

.vfm-fullscreen-content {
  margin: 0px auto;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.modal-header {
  position: relative;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  padding: 20px 50px 10px;

  color: #1F163B;
  //border-bottom: 1px solid linear-gradient(58.17deg, #2D2D86 0.79%, #F0494F 100%);;

  &::after {
    position: absolute;
    content: "";
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(58.17deg, var(--primary-color, #2D2D86) 0.79%, #F0494F 100%);
  }

  .btn-close {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}

.modal-body {
  padding: 20px 50px;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .vfm-fullscreen,
.modal-leave-active .vfm-fullscreen {
  transform: scale(1.1);
}


</style>
